import { render, staticRenderFns } from "./phoneRetrieve.vue?vue&type=template&id=122d4b18&scoped=true&"
import script from "./phoneRetrieve.vue?vue&type=script&lang=js&"
export * from "./phoneRetrieve.vue?vue&type=script&lang=js&"
import style0 from "./phoneRetrieve.vue?vue&type=style&index=0&id=122d4b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d4b18",
  null
  
)

export default component.exports